"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeContacts_en_us = void 0;
function backofficeContacts_en_us() {
    return {
        "backoffice.contacts.tab": "Contacts",
        "backoffice.contacts.title": "Contacts",
        "backoffice.contacts.subtitle": "Create and manage your CRM contacts.",
        "backoffice.contacts.editor.edit": "Edit Contact",
        "backoffice.contacts.editor.create": "Create Contact",
        "backoffice.contacts.editor.personal": "Personal",
        "backoffice.contacts.editor.reachability": "Reachability",
        "backoffice.contacts.editor.company": "Company",
        "backoffice.contacts.editor.customfields": "Custom Contact Fields",
        "backoffice.contacts.editor.notes": "Notes",
        "backoffice.contacts.detail.title": "Contact Details",
        "backoffice.contacts.customfield.tab": "Contact Fields",
        "backoffice.contacts.customfield.title": "Custom Contact Fields",
        "backoffice.contacts.customfield.subtitle": "Create your own custom contact fields which will be added to all your contacts.",
        "backoffice.contacts.customfield.titleprop": "Contact field titel",
        "backoffice.contacts.customfield.titledescription": "The title that describes the custom contact field.",
        "backoffice.contacts.customfield.name": "Contact field key",
        "backoffice.contacts.customfield.namedescription": "Key consisting of one word under which the contact field is saved. Each field needs a unique key. (e.g. isVegetarian)",
        "backoffice.contacts.customfield.type": "Contact field type",
        "backoffice.contacts.customfield.typedescription": "Which type of data the contact field contains.",
        "backoffice.contacts.customfield.editexplaination": "Contact key and type can not be edited.",
        "backoffice.contacts.customfield.create": "Create new contact field",
        "backoffice.contacts.customfield.edit": "Edit contact field",
        "backoffice.contacts.customfield.deletion.title": "ATTENTION: Delete contact field",
        "backoffice.contacts.customfield.deletion.message": "ATTENTION: If you delete this contact field ALL contact fields of this typ will be removed from all your contacts. Be sure to know what you are doing. This action can not be reversed.",
        "backoffice.contacts.publicaccess.label": "Public Contact",
        "backoffice.contacts.publicaccess.description": "This contact can be viewed without authentication. This is required for unauthenticated access e.g. via the Check-In App."
    };
}
exports.backofficeContacts_en_us = backofficeContacts_en_us;
